import React, { type FC } from 'react'

import type { PartialReadonlyRecord } from '../../../../utils'

import { canServerBeDeleted, canServerBeDisabled, canServerBeEnabled, Capability, type CybusServer, StatusType, Translation } from '../../../../domain'

import { DeleteIcon, EnableIcon, PauseIcon } from '../../common'
import { DetailsActionButton } from '../../Details'
import { useAppUsecases } from '../../State'

const disableButtonLabels: PartialReadonlyRecord<StatusType, Translation> = {
    [StatusType.ENABLED]: Translation.DISABLE,
    [StatusType.ENABLING]: Translation.ENABLING,
}

export const HeaderActions: FC<{ resource: CybusServer }> = ({ resource }) => {
    const { bulkDeleteServersUsecase, bulkEnableServersUsecase, bulkDisableServersUsecase } = useAppUsecases()

    return (
        <>
            <DetailsActionButton
                data-testid="server-action-button"
                disabled={!canServerBeDisabled(resource) && !canServerBeEnabled(resource)}
                text={disableButtonLabels[resource.status] || Translation.ENABLE}
                capabilities={[Capability.SERVERS_MANAGE]}
                onClick={
                    canServerBeDisabled(resource)
                        ? () => bulkDisableServersUsecase.selectServers([resource.id])
                        : () => bulkEnableServersUsecase.selectServers([resource.id])
                }
                startIcon={canServerBeDisabled(resource) ? <PauseIcon /> : <EnableIcon />}
                showText
            />

            <DetailsActionButton
                data-testid="delete-server-button"
                text={Translation.DELETE}
                disabled={!canServerBeDeleted(resource)}
                capabilities={[Capability.SERVERS_MANAGE]}
                onClick={() => bulkDeleteServersUsecase.selectServers([resource.id])}
                startIcon={<DeleteIcon />}
                variant="dangerOutline"
            />
        </>
    )
}
